import { Helper } from "../core/util/helper";
import React from "react";
export default class FieldComment extends React.Component<FieldCommentProps, any> {
    constructor(props) {
        super(props);
    }

    
    render() {
        let text = this.props.text;
        if (Helper.isNullOrEmpty(text)) {
            text = this.props.field.text;
        }
        if (!Helper.isNullOrEmpty(text)) {
            return (
                <div style={this.props.divStyle} className="fieldComment">
                    <label style={this.props.labelStyle} className="fieldComment__label">{text}</label>
                </div>
            );
        } else {
            return (<></>);
        }
    };
}

interface FieldCommentProps {
    text: string;    
    labelStyle?: React.CSSProperties;
    divStyle?: React.CSSProperties;
    field?: {
        text?: string;
        labelStyle?: React.CSSProperties;
        divStyle?: React.CSSProperties;
    }
}